/**
 * Utility for loading domain-specific assets
 */

// Domain detection helper
export const isNo2HarmDomain = () => {
  return window.location.hostname === 'no2harm.com' || 
         window.location.hostname === 'www.no2harm.com' ||
         window.location.hostname.includes('no2harm.com') ||
         window.location.hostname.includes('no2harm');
};

/**
 * Load the appropriate asset for the current domain
 * @param {Object} assets - Object containing stopvio and no2harm assets
 * @param {any} assets.stopvio - The StopVio version of the asset
 * @param {any} assets.no2harm - The No2Harm version of the asset
 * @returns {any} - The domain-specific asset
 */
export const getDomainAsset = (assets) => {
  return isNo2HarmDomain() ? assets.no2harm : assets.stopvio;
};

// Examples of usage

// For images:
export const getLogo = () => {
  return getDomainAsset({
    stopvio: require('../assets/images/stopvio/stopvio-logo-main.png'),
    no2harm: require('../assets/images/no2harm/no2harm-logo-main.png')
  });
};

// For text content:
export const getSiteTitle = () => {
  return getDomainAsset({
    stopvio: 'StopVio Survivor Resource Center',
    no2harm: 'No2Harm Resource Center'
  });
};

// For CSS classes:
export const getThemeClass = () => {
  return getDomainAsset({
    stopvio: 'stopvio-theme',
    no2harm: 'no2harm-theme'
  });
};